import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SharedService } from '../Shared/Services/shared.service';
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class DownloadService {
  readonly APIurl = environment.apiUrl;
  constructor(private http: HttpClient, private shared: SharedService) { }

  DownloadAccessoriesPrices(sectorId: number | null) {
    return this.http.post(`${this.APIurl}/download/PricesListToPdf?parentProductCategoryId=7&sectorId=${sectorId == null ? '' : sectorId}`, null, this.shared.GetOptionsForDownLoad());
  }

  DownloadSectorPrices(sectorId: number | null) {
    return this.http.post(`${this.APIurl}/download/PricesListToPdf?parentProductCategoryId=5&sectorId=${sectorId == null ? '' : sectorId}`, null, this.shared.GetOptionsForDownLoad());
  }

  CostCalcsToPdf(data: any) {
    return this.http.post(`${this.APIurl}/download/CostCalcsToPdf`, data, this.shared.GetOptionsForDownLoad());
  }

  InvoiceToPdf(data: any) {
    return this.http.post(`${this.APIurl}/download/InvoiceToPdf`, data, this.shared.GetOptionsForDownLoad());
  }

  HowToCutToPdf(data: any) {
    return this.http.post(`${this.APIurl}/download/HowToCutToPdf`, data, this.shared.GetOptionsForDownLoad());
  }

  ContractToPdf(contractId: any) {
    return this.http.post(this.ContractPDFUrl(contractId), null, this.shared.GetOptionsForDownLoad());
  }

  ContractPDFUrl(contractId: any): string{
    return `${this.APIurl}/download/ContractToPdf?contractId=${contractId}`;
  }
}
